export default {"src":"/_next/static/media/manage_calendar.f6cc6eea.svg","height":82,"width":103,"blurWidth":0,"blurHeight":0};